export const phanLoaiSanPham = {
  sections: {
    list: { title: 'Product classification' },
  },
  titles: { add: 'Add classification', edit: 'Edit classification' },
  columns: {
    summary: 'Classification name',
    note: 'Note',
    ngayTao: 'Created at',
    ngayCapNhat: 'Updated at',
    status: 'Status',
    onOffAction: 'On/off',
  },
  filter: {
    searchPlaceholder: 'Search by classification name...',
    textDetailTitle: 'Detailed filters',
  },
  filters: {
    statusAll: 'All',
  },
  status: {
    dangHoatDong: 'Active',
    ngungHoatDong: 'Inactive',
  },
  messages: {
    loadError: 'Could not load classifications.',
    deleteSuccess: 'Classification deleted.',
    noData: 'No classifications.',
    listSummary: '{count} items',
    saveSuccess: 'Classification saved.',
    statusChanged: 'Status updated.',
    selectedCount: '{count} selected',
    deleteSelected: 'Delete selected ({count})',
    bulkDeleteConfirm: 'Delete {count} selected classifications?',
    bulkDeleteSuccess: 'Deleted {count} classifications',
    bulkDeletePartial: 'Deleted {ok}/{total}. {failed} could not be deleted.',
    bulkDeleteError: 'Bulk delete failed',
    bulkDeleteNoneSelected: 'No classification selected',
  },
  form: {
    tenPhanLoai: 'Classification name',
  },
  validation: {
    tenRequired: 'Enter a classification name.',
  },
}
